let scriptsWithOnLoadToAttach: Array<{
  scriptId: string;
  onLoad: () => void;
}> = [];

const externalScriptsHeadObserver = new MutationObserver((_, observer) => {
  // get array of scripts that need to have inLoad attached
  scriptsWithOnLoadToAttach = scriptsWithOnLoadToAttach.filter(
    ({ scriptId, onLoad }) => {
      const scriptElement = document.getElementById(
        scriptId,
      ) as HTMLScriptElement | null;
      // if script is found as has type === 'text/javascript'
      // attach onLoad and remove it from array
      if (scriptElement?.type === 'text/javascript') {
        scriptElement.onload = onLoad;
        return false;
      }
      return true;
    },
  );
  // if there are no more scripts to attach disconnect observer
  if (!scriptsWithOnLoadToAttach.length) {
    observer.disconnect();
  }
});

export function injectExternalScript({
  providerName,
  id,
  onLoad,
  attributeMap,
}: {
  providerName: string;
  id: string;
  onLoad?: () => void;
  attributeMap?: Record<string, string>;
}): void {
  const scriptElement = document.createElement('script');
  if (attributeMap) {
    Object.entries(attributeMap).forEach(([attributeName, attributeValue]) => {
      scriptElement.setAttribute(attributeName, attributeValue);
    });
  }
  scriptElement.setAttribute('id', id);
  scriptElement.setAttribute('data-usercentrics', providerName);
  scriptElement.setAttribute('type', 'text/plain');

  document.head.appendChild(scriptElement);

  // if onLoad needs to be attached make sure observer is running
  // and queue this script to have onLoad attached
  if (onLoad) {
    if (!scriptsWithOnLoadToAttach.length) {
      externalScriptsHeadObserver.observe(document.head, { childList: true });
    }
    scriptsWithOnLoadToAttach.push({ scriptId: id, onLoad });
  }

  // force UC to check scripts with data-usercentrics attribute
  // and change their type to 'text/javascript' if they have appropriate consent,
  // if UC in not initialized yet this action will be performed automatically on init
  window.UC_UI?.enableScriptsForServicesWithConsent?.();
}
